<template>
  <div>
    <!-- 通用领取开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe line" v-html="modulesRules"></p>
      <div class="actSlider_v">
        <div class="actSlider_tab_v" :class="'actSlider_tab-' + tabSize">
          <a
            href="javascript:;"
            class="actSlider_tabItems_v"
            :class="{ active: activeIndex == index }"
            v-for="(tabItem, index) in tabItems"
            :key="tabItem.index"
            @click="activeIndex = index"
            >{{ tabItem.tabText }}</a
          >
        </div>
        <div>
          <div
            class="actSlider_content_v"
            v-show="activeIndex === index"
            v-for="(tabItem, index) in tabItems"
            :key="index"
          >
            <div class="actSlider_contentItems">
              <img v-if="tabItem.image" :src="tabItem.image.value" />
            </div>
            <template>
              <div class="actModules_btnWrap">
                <template v-if="!!h5Geted[index]">
                  <a
                    href="javascript:;"
                    class="disabled actModules_btn_v"
                    v-text="tabItem.buttonName"
                  ></a>
                </template>
                <template v-else>
                  <a
                    href="javascript:;"
                    @click="doAction"
                    class="actModules_btn_v"
                    v-text="tabItem.buttonName"
                  ></a>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 通用领取结束-->
  </div>
</template>

<script>
import '../../assets/css/reset.css';
import bus from '../../../bus';
import { mixins } from '../../../src/h5mixins';
import { buryingPoint } from '../buryingPoint/receive';
export default {
	name: 'h5-two-vertical',
	mixins: mixins,
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '规则描述',
			tabItems: '选项',
			name: '名称',
			image: '图片',
			action: '动作',
			tabText: 'Tab文案',
			buttonName: '按钮文案'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		bgImg: {
			type: String,
			default: ''
		},
		modulesRules: {
			type: String,
			default:
        '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案'
		},
		tabItems: {
			type: Array,
			default () {
				return [
					{
						tabText: '1',
						image: {
							class: 'image',
							value: ''
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						buttonName: '功能按钮1'
					},
					{
						tabText: '2',
						image: {
							class: 'image',
							value: ''
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						buttonName: '功能按钮2'
					}
				];
			}
		}
	},
	data () {
		return {
			activeIndex: 0,
			tabSize: 2,
			geted: [false, false],
			h5Geted: [false, false],
			moduleid: '0'
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		bus.$on('giftReceivedStatus', isGetedh5 => {
			if (typeof isGetedh5 === 'undefined') {
				return;
			}
			for (let i = 0; i < this.tabItems.length; i++) {
				let idx = this.tabItems[i].h5Action.ruleId;
				if (typeof isGetedh5['h' + idx] !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.h5Geted, i, true);
					} else {
						this.h5Geted[i] = false;
					}
				} else {
					this.h5Geted[i] = false;
				}
			}
			console.log(this.h5Geted);
		});
	},
	methods: {
		doAction () {
			if (this.$actMode !== 'production') {
				return;
			}
			const itemConf = this.tabItems[this.activeIndex];
			if (itemConf.h5Action.type === 'received') {
				this.receiveGift(itemConf.h5Action.type, itemConf.h5Action.value);
			} else if (itemConf.h5Action.type === 'gotoApp') {
				this.$gotoApp(itemConf.h5Action.value);
			} else if (itemConf.h5Action.type === 'link') {
				window.location.href = itemConf.h5Action.value;
			}
		},
		receiveGift (actionType, actionValue) {
			this.$doAction(actionType, actionValue)
				.then(({ sPackageName, iPackageId }) => {
					if (sPackageName) {
						alert(`恭喜你获得了${sPackageName}，请到游戏中查收`);
						this.$set(this.h5Geted, this.activeIndex, true);
						buryingPoint(this.modulesTitle, this.$axios);
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		}
	}
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";
.actModules_btnWrap {
  margin-top: 0.3rem;
  font-size: 0;
  -webkit-box-align: center;
  box-align: center;
  -webkit-box-pack: center;
  box-pack: center;
  display: -webkit-box;
  display: box;
}

.actSlider_v {
  width: 7.3rem;
  height: 3.8rem;
  margin: 0.1rem auto 0;
  background: #4a4a4a;
  @extend %box;
  -webkit-box-pack: center;
  box-pack: center;
  @include box-align(start);

  img {
    width: 100%;
  }
}

.actSlider_tab_v {
  width: 1.5rem;
  padding: 0;
  margin-top: 0.13rem;
}

.actSlider_content_v {
  width: 5.4rem;
  height: 3rem;
  padding: 0;
  margin-top: 0.4rem;
  margin-right: 0.22rem;
}

.actSlider_tabItems_v {
  width: 1.46rem;
  height: 0.7rem;
  @extend %box;
  @include box-align();
  -webkit-box-pack: center;
  box-pack: center;
  color: #fff;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size: 0;
  background: #dbdbdb;

  &.active {
    color: #000;
  }
}

.actSlider_tab {
  @extend %clearfix;
}

.actSlider_tabItems {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.24rem;
  text-align: center;
  background: #a4a4a4;
  color: #4a4a4a;
  @extend %block;
  @extend %left;
  border: 1px solid #666666;

  &.active {
    background: #d8d8d8;
  }
}
.vertical {
  .actSlider_contentItems {
    width: 5.4rem;
    height: 3rem;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.actModules_btn_v {
  @extend %box;
  @include box-align(center);
  -webkit-box-pack: center;
  box-pack: center;
  font-size: 0.24rem;
  color: #4a4a4a;
  margin: 0 0.42rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: #dbdbdb;
  width: 2.4rem;
  height: 0.7rem;

  &.disabled {
    color: #fff;
  }
}

.actRules {
  font-size: 0.24rem;
  color: #4a4a4a;
  width: 7.3rem;
  margin: 0.34rem auto 0;
}

.common-footerWrap {
  margin-top: 1rem;
}

.sellBanner {
  width: 7.3rem;
  margin: 0 auto;

  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/receive-v/x-two-vertical.vue